module.exports = __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.ece6673e.woff2";